import { Injectable } from "@angular/core";
import { InspectionType } from "../types/Inspection/InspectionType";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";

@Injectable({
  providedIn: "root",
})
export class InspectionTypeRepository extends ArrayClientRepository<InspectionType> {
  constructor(clientService: ClientService) {
    super(
      clientService,
      "schemas.schCFG_IREF_Type.records",
      "inspectionTypeID",
    );
  }
}
